import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ede02ce6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "px-5 container" }
const _hoisted_2 = { class: "mb-3" }
const _hoisted_3 = { class: "fw-bold" }
const _hoisted_4 = { class: "d-flex gap-5 section" }
const _hoisted_5 = { class: "p-4 mt-3 buy-container" }
const _hoisted_6 = { class: "fw-normal" }
const _hoisted_7 = { class: "confirmation" }
const _hoisted_8 = { class: "fw-normal mb-3" }
const _hoisted_9 = { class: "p-4 mt-3 buy-container" }
const _hoisted_10 = { class: "fw-normal" }
const _hoisted_11 = { class: "mb-4" }
const _hoisted_12 = { for: "AddCupom" }
const _hoisted_13 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_14 = {
  key: 1,
  class: "p-text-valid"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_ds_button = _resolveComponent("ds-button")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", null, [
      _createElementVNode("h4", _hoisted_2, _toDisplayString(_ctx.$t("financial.buyCredits")), 1),
      _createElementVNode("div", null, [
        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t("financial.currentBalance")) + ":", 1),
        _createTextVNode(" " + _toDisplayString(_ctx.currentBalance) + " " + _toDisplayString(_ctx.$t("computer.fields.credits")), 1)
      ])
    ]),
    _createElementVNode("section", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("h6", null, _toDisplayString(_ctx.$t("financial.payment")), 1),
        _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t("financial.selectQuant")), 1),
        _createVNode(_component_InputNumber, {
          modelValue: _ctx.creditQtd,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.creditQtd) = $event)),
          inputId: "horizontal-buttons",
          showButtons: "",
          buttonLayout: "horizontal",
          step: 1,
          class: "mb-4 text-align-center",
          decrementButtonClass: "p-button",
          incrementButtonClass: "p-button",
          incrementButtonIcon: "pi pi-plus",
          decrementButtonIcon: "pi pi-minus",
          min: 0,
          "input-style": "width:5rem;text-align:center;"
        }, null, 8, ["modelValue"]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.$t("financial.payDisclaimer")), 1),
          _createVNode(_component_ds_button, {
            type: "secondary",
            text: _ctx.$t('utils.cancel'),
            class: "me-4",
            onClick: _ctx.cancelOperation
          }, null, 8, ["text", "onClick"]),
          _createVNode(_component_ds_button, {
            type: "primary",
            text: _ctx.$t('financial.goPay'),
            onClick: _ctx.sendPayment,
            leftIcon: "open_in_new"
          }, null, 8, ["text", "onClick"])
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("h6", null, _toDisplayString(_ctx.$t("financial.couponHours")), 1),
        _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.$t("financial.insertCoupon")), 1),
        _createElementVNode("div", null, [
          _createVNode(_component_ds_button, {
            type: "tertiary",
            text: _ctx.$t('financial.applyCoupon'),
            leftIcon: "sell",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.visible = true))
          }, null, 8, ["text"])
        ])
      ])
    ]),
    _createVNode(_component_Dialog, {
      visible: _ctx.visible,
      "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.visible) = $event)),
      modal: "",
      header: "Cupom",
      style: { width: '25vw' }
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_ds_button, {
          text: _ctx.$t('utils.cancel'),
          type: "secondary",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.visible = false))
        }, null, 8, ["text"]),
        _createVNode(_component_ds_button, {
          text: _ctx.$t('utils.finish'),
          type: "primary",
          onClick: _ctx.finishOperation
        }, null, 8, ["text", "onClick"])
      ]),
      default: _withCtx(() => [
        _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.$t("financial.caseCoupon")), 1),
        _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.$t("financial.addCoupon")), 1),
        _createElementVNode("div", null, [
          _createElementVNode("div", null, [
            _createVNode(_component_InputText, {
              id: "AddCupom",
              inputId: "AddCupom",
              modelValue: _ctx.coupomCode,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.coupomCode) = $event)),
              placeholder: "Cupom",
              class: _normalizeClass(["mb-2 me-2 w-75", `${_ctx.coupomFail ? 'p-invalid' : ''}`])
            }, null, 8, ["modelValue", "class"]),
            _createVNode(_component_ds_button, {
              text: _ctx.$t('financial.apply'),
              type: "primary",
              onClick: _ctx.applyCoupon
            }, null, 8, ["text", "onClick"])
          ]),
          (_ctx.coupomFail && _ctx.showMessage)
            ? (_openBlock(), _createElementBlock("small", _hoisted_13, _toDisplayString(_ctx.checkCupomMessenge), 1))
            : (!_ctx.coupomFail && _ctx.showMessage)
              ? (_openBlock(), _createElementBlock("small", _hoisted_14, _toDisplayString(_ctx.checkCupomMessenge), 1))
              : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}